/**
 * Format discount amount in abbreviated format
 * e.g., 50000 -> "-50rb", 1500 -> "-2rb", 500 -> "-500"
 *
 * Used for voucher DISCOUNT_AMOUNT badge display across:
 * - Cart page (CartItemPromoPrice)
 * - Order detail (OrderDetailPromoPrice)
 */
export const formatDiscountAmountAbbreviated = (
  amount: number | null | undefined
): string => {
  if (amount == null || !Number.isFinite(amount)) {
    return '';
  }

  if (amount >= 1000) {
    const thousands = Math.round(amount / 1000);
    return `-${thousands}rb`;
  }

  return `-${Math.round(amount)}`;
};
